{
  "toast": {
    "created": "Quiz created successfully!",
    "createError": "Error creating quiz",
    "updated": "Quiz updated successfully!",
    "updateError": "Error updating quiz",
    "deleted": "Quiz deleted successfully!",
    "deleteError": "Error deleting quiz",
    "started": "Quiz started!",
    "startError": "Error starting quiz",
    "passed": "Congratulations! You passed with {{score}}%!",
    "failed": "You scored {{score}}%. Try again!",
    "submitError": "Error submitting quiz"
  },
  "questionType": {
    "multipleChoice": "Multiple choice",
    "trueFalse": "True/False",
    "essay": "Essay"
  },
  "player": {
    "questionNumber": "Question {{number}}",
    "points": "{{points}} pts",
    "hint": "Hint:",
    "previous": "Previous",
    "submitting": "Submitting...",
    "finish": "Finish quiz",
    "next": "Next",
    "answeredCount": "Answered: <highlight>{{answered}}</highlight> of {{total}}",
    "passingScore": "Passing score: <highlight>{{score}}%</highlight>",
    "exit": "Exit quiz"
  },
  "results": {
    "passedTitle": "Congratulations!",
    "failedTitle": "Keep trying!",
    "passedDescription": "You passed the quiz!",
    "failedDescription": "Don't give up! Review the content and try again.",
    "yourScore": "Your score",
    "passingScore": "Passing score",
    "correct": "Correct",
    "wrong": "Wrong",
    "accuracy": "Accuracy",
    "time": "Time",
    "completedAt": "Completed on {{date}}",
    "completedAtFormat": "MMMM d, yyyy 'at' h:mm a",
    "review": "Question review",
    "answerCorrect": "Correct",
    "answerIncorrect": "Incorrect",
    "pointsOf": "{{points}}/{{total}} pts",
    "explanation": "Explanation:",
    "backToCourse": "Back to course",
    "viewCertificate": "View certificate",
    "retry": "Try again",
    "retryInfo": "You can try again. Attempt limit: {{max}}",
    "noRetries": "⚠️ You can't try again. Review the course content."
  },
  "studentPlayer": {
    "timeUp": "Time's up! Submitting answers...",
    "starting": "Starting quiz...",
    "loadError": "Error loading the quiz",
    "reloadHint": "Try reloading the page",
    "questionOf": "Question {{number}} of {{total}}",
    "answered_one": "{{count}} answered",
    "answered_zero": "{{count}} answered",
    "answered_other": "{{count}} answered",
    "progress": "Progress",
    "question": "Question {{number}}",
    "points_one": "{{count}} point",
    "points_zero": "{{count}} points",
    "points_other": "{{count}} points",
    "yourAnswer": "Your answer:",
    "answerPlaceholder": "Type your answer here...",
    "essayHint": "Be detailed in your answer. Essay questions are graded manually.",
    "previous": "Previous",
    "answeredOf": "{{answered}}/{{total}} questions answered",
    "next": "Next",
    "finish": "Finish quiz",
    "instructions": "Instructions",
    "timeAlmostUp": "Time is almost up!",
    "timeRemaining": "Only {{time}} left"
  },
  "studentResults": {
    "perfect": {
      "title": "🏆 PERFECT!",
      "subtitle": "You aced this quiz!"
    },
    "excellent": {
      "title": "🌟 EXCELLENT!",
      "subtitle": "Great performance!"
    },
    "passed": {
      "title": "✅ PASSED!",
      "subtitle": "You passed this quiz!"
    },
    "failed": {
      "title": "❌ FAILED",
      "subtitle": "Keep studying and try again!"
    },
    "correctOf": "{{correct}}/{{total}} questions correct",
    "passingScore": "Passing score",
    "timeSpent": "Time spent",
    "correct": "Correct",
    "pointsEarned": "+{{points}} points earned!",
    "review": "Answer review",
    "question": "Question {{number}}",
    "answerCorrect": "Correct",
    "answerIncorrect": "Incorrect",
    "yourAnswerBadge": "Your answer",
    "yourAnswer": "Your answer:",
    "essayNote": "* Essay questions are graded manually",
    "explanation": "Explanation",
    "retry": "Try again",
    "continue": "Keep studying",
    "noRetries": "This quiz doesn't allow retries. Review the material and keep studying.",
    "tips": {
      "title": "Tips to improve",
      "review": "<bold>Review the material:</bold> It looks like you need more time studying this content. Revisit the lessons and supplementary materials.",
      "almost": "<bold>Almost there:</bold> You have a good foundation, but there's room to improve. Focus on the areas you missed and practice more.",
      "goodJob": "<bold>Good job:</bold> You know the content well! With a bit more attention to detail, you can reach excellence.",
      "time": "<bold>Time management:</bold> You used almost all the available time. Practice more to answer faster."
    }
  }
}
